// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__K3Fjs","navHeading":"Tabs_navHeading__1Ije0","heading":"Tabs_heading__JtlOG","text":"Tabs_text__4fkWU"};